import type { holidays_HolidayResponse } from "@/api/models/holidays_HolidayResponse";
import type { holidays_CreateHolidayRequest } from "@/api/models/holidays_CreateHolidayRequest";
import type { holidays_UpdateHolidayRequest } from "@/api/models/holidays_UpdateHolidayRequest";

// Stable domain aliases over the generated OpenAPI holiday models. Import these
// from `@/types/...` (per the import-from-types convention), not from `@/api`
// directly. NOTE: the generated holiday models use camelCase fields
// (holidayDate, childcareId, …), so this alias keeps that casing — there is no
// snake_case remapping for holidays.
export type PublicHoliday = holidays_HolidayResponse;
export type CreatePublicHolidayInput = holidays_CreateHolidayRequest;
export type UpdatePublicHolidayInput = holidays_UpdateHolidayRequest;

// The fixed holiday type for every row this admin page manages. The workforce
// engine credits target hours on PUBLIC_HOLIDAY dates; SCHOOL_CLOSURE /
// DAYCARE_CLOSURE are managed elsewhere.
export const PUBLIC_HOLIDAY_TYPE = "PUBLIC_HOLIDAY" as const;
